module.exports = __webpack_public_path__ + "img/phantom_assassin_alt1.e0f629ff.png";